import { render, staticRenderFns } from "./showData.vue?vue&type=template&id=312edb97&"
import script from "./showData.vue?vue&type=script&lang=js&"
export * from "./showData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports